import * as yup from 'yup';

const mobilePaymentSchema = yup
    .object({
        bankId: yup
            .number()
            .required('Debe seleccionar un banco')
            .min(1, 'Debe seleccionar un banco'),
        isDirectDebitMode: yup.boolean().required(),
        date: yup.string().when('isDirectDebitMode', {
            is: false,
            then: (schema) =>
                schema
                    .matches(
                        /^\d{2}\/\d{2}\/\d{4}$/,
                        'Formato DD/MM/YYYY inválido'
                    )
                    .required('Fecha requerida'),
            otherwise: (schema) => schema.optional(),
        }),
        referenceCode: yup
            .string()
            .min(6, 'Referencia debe tener al menos 6 dígitos')
            .optional(),
        isThirdPartyPayer: yup.boolean().required(),
        phone: yup.string().when('isThirdPartyPayer', {
            is: true,
            then: (schema) =>
                schema
                    .matches(
                        /^(\+58|58|0)(412|422|424|414|416|426)\d{7}$/,
                        'Formato inválido (ej: 04121234567)'
                    )
                    .required('Teléfono requerido'),
            otherwise: (schema) => schema.optional(),
        }),
        nin: yup.string().when('isThirdPartyPayer', {
            is: true,
            then: (schema) =>
                schema.min(6, 'CI inválida').required('CI requerida'),
            otherwise: (schema) => schema.optional(),
        }),
        name: yup.string().when('isThirdPartyPayer', {
            is: true,
            then: (schema) =>
                schema.min(2, 'Nombre inválido').required('Nombre requerido'),
            otherwise: (schema) => schema.optional(),
        }),
        documentType: yup.string().when('isThirdPartyPayer', {
            is: true,
            then: (schema) =>
                schema
                    .oneOf(['V', 'E'], 'Tipo de documento inválido')
                    .required('Tipo de documento requerido'),
            otherwise: (schema) => schema.optional(),
        }),
    })
    .required();

const casheaSchema = yup
    .string()
    .min(3, 'Mínimo 3 caracteres')
    .required('Número de compra requerido');

const zelleSchema = yup
    .string()
    .min(3, 'Mínimo 3 caracteres')
    .required('Nombre del titular requerido');

export { mobilePaymentSchema, casheaSchema, zelleSchema };
